module.exports = __webpack_public_path__ + "img/hospital2.7e847c33.png";